import { IZoneData, Zones as ZonesLib } from "@package/map";
import Api from "Api";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { setTooltip } from "Redux/tooltipSlice";
import { changeApplySelected, changeAutoApply } from "Redux/zonesSlice";
import { changeLoadingMode } from "Redux/surveysSlice";
import { useEffect, useMemo, useState } from "react";
import { Marker, Pane, Rectangle, Tooltip } from "react-leaflet";
import _ from "lodash";
import { useQuery } from "@tanstack/react-query";

export default function HeatMap2() {
  const dispatch = useAppDispatch();

  const {
    source,
    destination,
    level,
    visible: zonesVisible,
    zone,
    zonesCount,
    showTopNumbers,
    heatMap2Mode,
    selectingType,
    autoApply,
    applySelecteds,
    forceUpdate,
    colorStep,
    showHeatMap2Numbers,
  } = useAppSelector((state) => state.zones);
  const { visible: surveysVisible, surveyShowType, type } = useAppSelector((state) => state.surveys);
  const { zoom } = useAppSelector((state) => state.map);
  const { survayLayer } = useAppSelector((state) => state.layers);
  const StorageZonesData = useMemo(() => localStorage.getItem(`zone-data-${zone}-${level}`), [zone, level]);
  const [zonesData, setZonesData] = useState(StorageZonesData ? JSON.parse(StorageZonesData) : []);
  const [selectedZonesCount, setSelectedZonesCount] = useState<any>({ des: {}, src: {} });
  const [surveyCounts, setSurveyCounts] = useState<any>({ des: {}, src: {}, storedDes: {}, storedSrc: {} });
  const [allSurveyCounts, setAllSurveyCounts] = useState<any>({ des: {}, src: {} });
  // useEffect(() => {
  //   const allZones = localStorage.getItem(`zone-data-${zone}-${level}`);
  //   if (allZones) {
  //     setZonesData(JSON.parse(allZones));
  //   }
  // }, [level]);
  useEffect(() => {
    const getCounts = async () => {
      const res = await Api.post(`survey/count-by-zones`, {
        sources: [],
        destinations: [],
        created_after: type === "people" ? "2020-09-23 00:00:01" : "",
        // created_before: "2032-08-25 20:15:00",
        input: type,
      });
      console.log(res, "ohunuionhin");
      setSurveyCounts({ des: res?.data?.Data?.destinationCount, src: res?.data?.Data?.sourceCount });
      setAllSurveyCounts({ des: res?.data?.Data?.destinationCount, src: res?.data?.Data?.sourceCount });
    };
    if (!applySelecteds) {
      getCounts();
    }
    return () => {
      dispatch(changeAutoApply(false));
      dispatch(changeApplySelected(false));
    };
  }, [type]);

  useEffect(() => {
    if (!zonesVisible) {
      dispatch(changeAutoApply(false));
      dispatch(changeApplySelected(false));
    }
  }, [zonesVisible]);

  const { data, isLoading, refetch, isFetching } = useQuery({
    queryKey: [applySelecteds, source, destination, autoApply, surveyShowType, type],
    queryFn: () => {
      if (autoApply || surveyShowType === 2) {
        if (source.length === 0 && destination.length > 0) {
          const temp: any = {};
          for (let i = 0; i < destination.length; i += 1) {
            const c = allSurveyCounts.des[destination[i]];
            if (c) {
              temp[String(destination[i])] = c;
            } else {
              temp[String(destination[i])] = 0;
            }
          }
          return Api.post(`survey/count-by-zones`, {
            sources: source,
            destinations: destination,
            created_after: type === "people" ? "2020-09-23 00:00:01" : "",
            // created_before: "2032-02-25 20:15:00",
            input: type,
          }).then((res) => {
            setSurveyCounts({ des: temp, src: res?.data?.Data?.sourceCount });
          });
        }
        if (destination.length === 0 && source.length > 0) {
          const temp: any = {};
          for (let i = 0; i < source.length; i += 1) {
            const c = allSurveyCounts.src[source[i]];
            if (c) {
              temp[String(source[i])] = c;
            } else {
              temp[String(source[i])] = 0;
            }
          }
          return Api.post(`survey/count-by-zones`, {
            sources: source,
            destinations: destination,
            created_after: type === "people" ? "2020-09-23 00:00:01" : "",
            // created_before: "2032-02-25 20:15:00",
            input: type,
          }).then((res) => {
            setSurveyCounts({ des: res?.data?.Data?.destinationCount, src: temp });
          });
        }
        return Api.post(`survey/count-by-zones`, {
          sources: source,
          destinations: destination,
          created_after: type === "people" ? "2020-09-23 00:00:01" : "",
          // created_before: "2032-02-25 20:15:00",
          input: type,
        }).then((res) => {
          setSurveyCounts({ des: res?.data?.Data?.destinationCount, src: res?.data?.Data?.sourceCount });
        });
      }
      if (!autoApply && applySelecteds) {
        if (source.length === 0 && destination.length > 0) {
          const temp: any = {};
          for (let i = 0; i < destination.length; i += 1) {
            const c = allSurveyCounts.des[destination[i]];
            if (c) {
              temp[String(destination[i])] = c;
            } else {
              temp[String(destination[i])] = 0;
            }
          }
          return Api.post(`survey/count-by-zones`, {
            sources: source,
            destinations: destination,
            created_after: type === "people" ? "2020-09-23 00:00:01" : "",
            // created_before: "2032-02-25 20:15:00",
            input: type,
          }).then((res) => {
            setSurveyCounts({ des: temp, src: res?.data?.Data?.sourceCount });
          });
        }
        if (destination.length === 0 && source.length > 0) {
          const temp: any = {};
          for (let i = 0; i < source.length; i += 1) {
            const c = allSurveyCounts.src[source[i]];
            if (c) {
              temp[String(source[i])] = c;
            } else {
              temp[String(source[i])] = 0;
            }
          }
          return Api.post(`survey/count-by-zones`, {
            sources: source,
            destinations: destination,
            created_after: type === "people" ? "2020-09-23 00:00:01" : "",
            // created_before: "2032-02-25 20:15:00",
            input: type,
          }).then((res) => {
            setSurveyCounts({ des: res?.data?.Data?.destinationCount, src: temp });
          });
        }
        return Api.post(`survey/count-by-zones`, {
          sources: source,
          destinations: destination,
          created_after: type === "people" ? "2020-09-23 00:00:01" : "",
          // created_before: "20332-02-25 20:15:00",
          input: type,
        }).then((res) => {
          setSurveyCounts({ des: res?.data?.Data?.destinationCount, src: res?.data?.Data?.sourceCount });
        });
      }
    },
    enabled: true,
  });

  useEffect(() => {
    dispatch(changeLoadingMode(isLoading));
  }, [isLoading]);

  if (!surveysVisible) return <></>;
  return (
    <>
      <Pane name="show_survay_heatmap2" style={{ zIndex: survayLayer }} key={survayLayer}>
        <ZonesLib
          zone={zone}
          level={level}
          zoom={zoom}
          zonesVisible={zonesVisible}
          heatMap={true}
          haetmapZIndex={survayLayer}
          heatMapMode={heatMap2Mode}
          autoApply={autoApply}
          applySelecteds={applySelecteds}
          zonesCount={showTopNumbers ? zonesCount : 329}
          showTopNumbers={showTopNumbers}
          forceUpdate={forceUpdate}
          colorStep={colorStep}
          surveyCounts={surveyCounts}
          allSurveyCounts={allSurveyCounts}
          isLoading={isLoading}
          selectedZonesCount={selectedZonesCount}
          showHeatMap2Numbers={showHeatMap2Numbers}
          selectionMode={applySelecteds && surveysVisible && surveyShowType === 2}
          zonesColor={[
            { zones: source, color: "#00a185" },
            { zones: destination, color: "#07243e" },
          ]}
        />
      </Pane>
      {/* {zonesData?.map((z: any, index: number) => {
        console.log(allSurveyCounts.src[String(z.zone.id)], "pl12");
        return (
          <Marker position={[z.properties.center_lat, z.properties.center_lng]}>
            <Tooltip direction="bottom" opacity={1} permanent>
              <div style={{ fontSize: "15px", color: "red" }}>
                <b>
                  {selectingType === "destination"
                    ? allSurveyCounts.src[String(z.zone.id)]
                    : allSurveyCounts.des[String(z.zone.id)]}
                </b>
              </div>
            </Tooltip>
            <Tooltip>Tooltip for Marker</Tooltip>
          </Marker>
        );
      })} */}
    </>
  );
}
